import { Location, LocationDescriptor, LocationDescriptorObject } from 'history';
import * as React from 'react';
import { NavLink, NavLinkProps, Route, useMatch } from 'react-router-dom';

interface IChildrenProps {
    active: boolean;
}

export interface IBaseNavLinkProps extends Omit<NavLinkProps, 'children'> {
    children: (props: IChildrenProps) => React.ReactNode;
    // Property for the css style which will make the cursor unset for child elements;
    disabled?: boolean;
}

export const BaseNavLink: React.FunctionComponent<IBaseNavLinkProps> = navProps => {
    const { children, disabled, ...linkProps } = navProps;
    // Pass end option to useMatch - defaults to false to match child routes
    const match = useMatch({ path: String(linkProps.to), end: linkProps.end ?? false });
    const hasMatch = !!match;
    const matchesExact = linkProps.end;
    const isNotExact = !linkProps.end;
    return (
        <NavLink {...linkProps} style={{ pointerEvents: disabled ? 'none' : 'auto' }}>
            {children({
                active: hasMatch && (matchesExact || isNotExact),
            })}
        </NavLink>
    );
};
